export default __webpack_public_path__ + "static/media/p78.f7bd1832.jpg";